import { Tag } from '@markdoc/markdoc'
import { Callout } from '@/components/markdoc/Callout'
import { Fence } from '@/components/markdoc/Fence'
import { QuickLink, QuickLinks } from '@/components/markdoc/QuickLinks'
import { MarkdocImage, RemoteImage } from '@/components/markdoc/Images'
import { Video } from '@/components/markdoc/Video'
import { Youtube, GoogleSlides } from '@/components/markdoc/iFrame'
import {
  Superscript,
  Footnote,
  ScrollBackToSuperscript,
} from '@/components/markdoc/Note'

const tags = {
  callout: {
    attributes: {
      title: { type: String },
      type: {
        type: String,
        default: 'note',
        matches: ['note', 'warning'],
        errorLevel: 'critical',
      },
    },
    render: Callout,
  },
  'quick-links': {
    render: QuickLinks,
  },
  'quick-link': {
    selfClosing: true,
    render: QuickLink,
    attributes: {
      title: { type: String },
      description: { type: String },
      icon: { type: String },
      href: { type: String },
    },
  },
  'blog-post-image': {
    selfClosing: true,
    render: MarkdocImage,
    attributes: {
      imageName: { type: String },
      alt: { type: String },
      className: { type: String },
      imgClassName: { type: String },
      priority: { type: Boolean },
    },
  },
  'remote-image': {
    selfClosing: true,
    render: RemoteImage,
    attributes: {
      imageName: { type: String },
      alt: { type: String },
      divClassName: { type: String },
      imgClassName: { type: String },
      priority: { type: Boolean },
    },
  },
  video: {
    selfClosing: true,
    render: Video,
    attributes: {
      googleCloudKey: { type: String },
      divClassName: { type: String },
    },
  },
  'google-slides': {
    selfClosing: true,
    render: GoogleSlides,
    attributes: {
      src: { type: String },
    },
  },
  youtube: {
    selfClosing: true,
    render: Youtube,
    attributes: {
      src: { type: String },
    },
  },
  superscript: {
    render: Superscript,
    selfClosing: true,
    attributes: {
      id: { type: Number },
    },
  },
  footnote: {
    selfClosing: true,
    render: Footnote,
    attributes: {
      id: { type: Number },
    },
  },
  'scroll-back': {
    selfClosing: true,
    render: ScrollBackToSuperscript,
    attributes: {
      id: { type: Number },
    },
  },
  'markdoc-example': {
    render: (props) =>
      Fence({
        ...props,
        shouldWrap: true,
        className: {
          container: 'not-prose',
          code: 'text-sm',
          'bg-color': 'bg-slate-800',
        },
      }),
    attributes: {
      language: {
        type: String,
      },
      highlights: {
        type: String,
      },
    },
    transform(node, config) {
      const attributes = node.transformAttributes(config)
      const { content, language } = node.children[0].attributes

      return new Tag(this.render, { ...attributes, language }, [content])
    },
  },
}

export default tags
